import _ from 'lodash'
import { List, Map, Record } from 'immutable'

import {
    TABS_SET_TAB_TEXT,
    TABS_ADD_TAB,
    TABS_REMOVE_TAB,
    TABS_REMOVE_TAB_FROM_OLD,
    TABS_ACTIVE_TAB,
    TAB_ACTIVATE_ON_CLICK,
    TABS_ADD_TAB_FROM_OLD,
} from './constants'

export const TabRecord = Record({
    id: null,
    type: null,
    text: '',
    active: false,
    fromOld: false,
    custom: Map(),
})

export const TabsRecord = Record({
    tabs: List(),
})

export default (state = new TabsRecord(), action = {}) => {
    switch (action.type) {
        case TABS_ADD_TAB: {
            const tabId = _.get(action, 'data.id', null)
            const tabType = _.get(action, 'data.type', null)
            const tabText = _.get(action, 'data.text', '')

            const tabs = state.get('tabs')
            const isInTabs = !!tabs.find((tab) => tab.get('id') === tabId && tab.get('type') === tabType)

            // if is in tabs, do nothing in reducer
            if (isInTabs) return state

            const newTab = new TabRecord({ id: tabId, type: tabType, text: tabText })
            return state.set('tabs', tabs.push(newTab))
        }
        case TABS_ADD_TAB_FROM_OLD: {
            const tabId = _.get(action, 'data.id', null)
            const tabType = _.get(action, 'data.type', null)
            const tabText = _.get(action, 'data.text', '')

            const tabs = state.get('tabs')
            const isInTabs = !!tabs.find((tab) => tab.get('id') === tabId && tab.get('type') === tabType)

            // if is in tabs, do nothing in reducer
            if (isInTabs) return state

            const newTab = new TabRecord({ id: tabId, type: tabType, text: tabText, fromOld: true })
            return state.set('tabs', tabs.push(newTab))
        }
        case TABS_REMOVE_TAB: {
            const tabId = _.get(action, 'data.id', null)
            const tabType = _.get(action, 'data.type', null)

            // all tabs without remove tab
            const tabs = state
                .get('tabs')
                .filter(
                    (tab) =>
                        !(String(tab.get('id')) === String(tabId) && tab.get('type') === tabType && !tab.get('fromOld'))
                )

            return state.set('tabs', tabs)
        }
        case TABS_REMOVE_TAB_FROM_OLD: {
            const tabId = _.get(action, 'data.id', null)
            const tabType = _.get(action, 'data.type', null)

            // all tabs without remove tab
            const tabs = state
                .get('tabs')
                .filter(
                    (tab) =>
                        !(String(tab.get('id')) === String(tabId) && tab.get('type') === tabType && tab.get('fromOld'))
                )

            return state.set('tabs', tabs)
        }
        case TABS_ACTIVE_TAB: {
            const tabId = _.get(action, 'data.id', null)
            const tabType = _.get(action, 'data.type', null)

            const tabs = state.get('tabs').map((tab) => {
                if (tab.get('type') !== tabType) return tab

                return tab.set('active', tab.get('id') === tabId)
            })

            return state.set('tabs', tabs)
        }
        case TAB_ACTIVATE_ON_CLICK: {
            const tabId = _.get(action, 'data.id', null)
            const tabType = _.get(action, 'data.type', null)

            const tabs = state.get('tabs').map((tab) => {
                if (tab.get('type') !== tabType) return tab

                return tab.set('active', tab.get('id') === tabId)
            })

            return state.set('tabs', tabs)
        }
        case TABS_SET_TAB_TEXT: {
            const tabId = _.get(action, 'data.id', null)
            const tabText = _.get(action, 'data.text', null)

            const newTabs = state.get('tabs').map((tab) => {
                if (tab.get('id') === tabId) return tab.set('text', tabText)
                return tab
            })

            return state.set('tabs', newTabs)
        }
        default:
            return state
    }
}
